import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { installDraggableAntModals } from '../utils/draggableAntModal';
import { useWorkbenchMobileLayout } from './useWorkbenchMobileLayout';
import { isYanxuanSurface } from '../config/yanxuanFeature';
import './draggable-ant-modal.css';

export function useDraggableAntModals(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    return installDraggableAntModals();
  }, [enabled]);
}

/**
 * 桌面端拖标题栏移动弹窗（DOM 级补丁）。
 * 仅严选界面生效：`/yanxuan*`、采购工作台严选通道（`?tab=yanxuan-*`）、平台端严选菜单（`?menu=yanxuan*`）；
 * 严选开关关闭或 1.0 页面（`/platform` 其余菜单、审批、供应商等）不安装，弹窗行为与现网一致。
 */
export function WorkbenchDraggableModals() {
  const { pathname, search } = useLocation();
  const isMobile = useWorkbenchMobileLayout();
  useDraggableAntModals(!isMobile && isYanxuanSurface(pathname, search));
  return null;
}
